<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { FormField } from "@shared/types/Form";

  export let name: string;
  export let id: string = name;
  export let field: FormField;
  export let placeholder = "";

  const dispatch = createEventDispatcher();

  const onBlur = (e: FocusEvent): void => {
    dispatch("blur", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onChange = (e: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
    dispatch("change", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onKeyUp = (e: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
    dispatch("keyUp", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onFocus = (e: FocusEvent): void => {
    dispatch("click", { target: e.currentTarget, field, fieldValue: $field });
  };

</script>

<style>
  @media screen and (max-width: 700px) {
    .smaller-mobile-placeholder-text {
      font-size: 0.875rem;
    }
  }

</style>

<input
  {name}
  {id}
  {placeholder}
  class="fizz-full-width fizz-input-search smaller-mobile-placeholder-text"
  class:fizz-input-error={!$field.valid}
  data-testId={id}
  type="search"
  bind:value={$field.value}
  on:blur={onBlur}
  on:change={onChange}
  on:focus={onFocus}
  on:keyup={onKeyUp}
/>
<slot />
